<template>
 <router-view></router-view>

</template>

<script setup>
import { onMounted, computed, watch ,ref } from 'vue'
import { updateFaviconAndTitle } from './utils/domUtils'
import { useStore } from 'vuex'
import { service } from '@/services/singleton.service';
const store = useStore()
const isLoading = ref(false);
// Computed getter for settings from Vuex
const user = computed(() => store.getters['auth/getSetting'])

// Run once on mount
onMounted(() => {
  getSettingList()
  if (user.value?.title && user.value?.favicon) {
    updateFaviconAndTitle(user.value.title, user.value.favicon)
  }
})

watch(
  user,
  (newVal) => {
    if (newVal?.title && newVal?.favicon) {
      updateFaviconAndTitle(newVal.title, newVal.favicon)
    }
  },
  { deep: true } 
)
const getSettingList = async () => {
  try {
    const res = await service.setting.getList([
      { key: 'take_all', value: 'true' },
    ]);
   
    await store.dispatch('auth/setSettings', res.data);
  } catch (error) {
    handleApiError(error);
  }
};
const handleApiError = (error) => {
  isLoading.value = false;
  if (error.response?.status === 422 || error.response?.status === 400) {
    service.notification.showError(error.response.data.message);
  } 
};
</script>


